<template lang="html">
  <div @click="uncover" :class="{'cover-default': true, 'cover': show}"></div>
</template>

<script>
export default {
  data: () => ({
    show: false
  }),

  props: {
    active: Boolean | null
  },

  methods: {
    cover () { this.show = true },

    uncover () { this.show = false },

    toggleCover () { this.show = !this.show }
  },

  mounted () {
    addEventListener('cover', this.cover)
    addEventListener('uncover', this.uncover)
    addEventListener('toggleCover', this.toggleCover)
  },

  beforeDestroy () {
    removeEventListener('cover', this.cover)
    removeEventListener('uncover', this.uncover)
    removeEventListener('toggleCover', this.toggleCover)
  }
}
</script>

<style lang="scss">
  .cover-default {
    display: none;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.5;

    &.cover {
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/CoverDefault.vue